import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';
import { Linking } from 'react-native';
import { API_BASE_URL } from '../config/api';

// fetches the SSO login URL from the backend and returns it without opening a window.
// keep this separate so callers can open a window synchronously before awaiting this,
// which avoids browser popup blockers cutting off the user gesture chain.
export const fetchZoolyfeIdSsoUrl = async () => {
  const authToken = await AsyncStorage.getItem('auth_token');

  if (!authToken) {
    throw new Error('Authentication token not found. Please login again.');
  }

  const response = await fetch(`${API_BASE_URL}/api/v1/createsso`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
      'X-Api-Key':
        Constants.expoConfig?.extra?.API_KEY ||
        '9f3c7a2d1b84e6f5c0a9d27e4b6f8a1c5d3e9b7a0c2f4e6d8a1b3c5f7e9d2',
    },
    body: new URLSearchParams({
      auth_token: authToken,
    }),
  });

  const result = await response.json();

  if (result.status !== 'success') {
    throw new Error(result.message || 'Failed to generate SSO login URL');
  }

  return result.data.login_url;
};

const withSsoRedirect = (loginUrl, redirectUrl) => {
  const target = String(redirectUrl || '/order').trim() || '/order';
  const path = /^https?:\/\//i.test(target)
    ? (() => {
        try {
          return new URL(target).pathname || '/order';
        } catch (e) {
          return '/order';
        }
      })()
    : (target.startsWith('/') ? target : `/${target}`);
  const sep = loginUrl.includes('?') ? '&' : '?';
  return `${loginUrl}${sep}redirect=${encodeURIComponent(path || '/order')}`;
};

const openInNewTab = (url) => {
  if (typeof window !== 'undefined' && window.open) {
    window.open(url, '_blank');
    return true;
  }
  return false;
};

export const openZoolyfeShopUrl = async (targetUrl) => {
  const destination = String(targetUrl || '').trim();
  let win = null;
  if (typeof window !== 'undefined') {
    win = window.open('', '_blank');
  }

  try {
    const loginUrl = withSsoRedirect(await fetchZoolyfeIdSsoUrl(), destination);
    if (win) {
      win.location.href = loginUrl;
      return loginUrl;
    }
    if (openInNewTab(loginUrl)) {
      return loginUrl;
    }
    await Linking.openURL(loginUrl);
    return loginUrl;
  } catch (error) {
    if (win) win.close();
    throw error;
  }
};

// convenience wrapper used by ProfileScreen / Referral — opens browser or in-app browser
export const openZoolyfeIdSso = async () => {
  const loginUrl = await fetchZoolyfeIdSsoUrl();
  if (typeof window !== 'undefined' && window.open) {
    window.open(loginUrl, '_blank');
  } else {
    await Linking.openURL(loginUrl);
  }
  return loginUrl;
};
